import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ITicket } from '../types/Ticket/ITicket';
import IForm, { IField } from '../types/Form/IForm';

const TicketDetailSlice = createSlice({
    name: 'ticketDetails',
    initialState: {
        details: {
            Call_Desc: '',
            Actions: [],
        } as ITicket,
        form: null as IForm,
        isClosing: false,
        pager: {
            ticketIds: [] as number[],
            currentIndex: 0,
        }
    },
    reducers: {
        setPagerCurrentIndex: (state, action: PayloadAction<number>) => {
            state.pager.currentIndex = action.payload;
        },
        setPagerTicketIds: (state, action: PayloadAction<number[]>) => {
            state.pager.ticketIds = action.payload;
        },
        setIsClosing: (state, action: PayloadAction<boolean>) => {
            state.isClosing = action.payload;
        },
        setForm: (state, action: PayloadAction<IForm>) => {
            state.form = action.payload
        },
        setDetails: (state, action: PayloadAction<ITicket>) => {
            state.details = action.payload;
        },
        setField: (state, action: PayloadAction<IField>) => {
            //state.ticket.CustomFormFields?.map(f => f.UID === action.payload.UID ? {...f, VALUES:action.payload.VALUES} : f);
            let foundField = state.form?.Fields?.filter(f => f.UID === action.payload.UID)
            if (foundField.length > 0) {
                foundField[0].VALUES = action.payload.VALUES;
                foundField[0].ConfigSettings = action.payload.ConfigSettings;
            } else {
                state.form?.Fields.push(action.payload);
            }
        },
    },
    extraReducers: (builder) => {

    },
});

export const { setField, setDetails, setForm, setIsClosing, setPagerCurrentIndex, setPagerTicketIds } = TicketDetailSlice.actions;
export default TicketDetailSlice.reducer;